export function percentage(value: number, total: number): string {
  if (total === 0) return '0%'

  if (value === 0 && total === 1) return '0%'

  return `${((value / total) * 100).toFixed(1)}%`
}

export function ratio(value: number, total: number): number {
  if (total === 0) return 0
  return value / total
}
